/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IExampleParent } from '../../../core/models/common/IExampleParent';
import { IOasHeaderParent } from '../../models/IOasHeaderParent';
import { OasHeader } from '../../models/OasHeader';
import { OasResponse } from '../../models/OasResponse';
import { Oas20Headers } from './Oas20Headers';
import { Oas20Schema } from './Oas20Schema';
import { Oas20Example } from './Oas20Example';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';
import { Oas20Header } from './Oas20Header';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends OasResponse
 * @author eric.wittmann@gmail.com
 */
export class Oas20Response extends OasResponse implements IOasHeaderParent, IExampleParent {
    public headers : Oas20Headers;

    public schema : Oas20Schema;

    public examples : Oas20Example;

    public constructor(name : string) {
        super(name);
        if(this.headers===undefined) this.headers = null;
        if(this.schema===undefined) this.schema = null;
        if(this.examples===undefined) this.examples = null;
    }

    /**
     * Creates an OAS 2.0 schema object.
     * @return {Oas20Schema}
     */
    public createSchema() : Oas20Schema {
        let rval : Oas20Schema = new Oas20Schema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates a http header.
     * @param {string} name
     * @return {Oas20Header}
     */
    public createHeader(name : string) : Oas20Header {
        let rval : Oas20Header = new Oas20Header(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates an OAS 2.0 headers object.
     * @return {Oas20Headers}
     */
    public createHeaders() : Oas20Headers {
        let rval : Oas20Headers = new Oas20Headers();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a header.
     * @param {string} name
     * @param {OasHeader} header
     */
    public addHeader(name : string, header : OasHeader) {
        this.headers.addHeader(name, <Oas20Header>header);
    }

    /**
     * Gets a single header by name.
     * @param {string} name
     * @return {OasHeader}
     */
    public getHeader(name : string) : OasHeader {
        return this.headers.getHeader(name);
    }

    /**
     * Removes a single header and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {OasHeader}
     */
    public removeHeader(name : string) : OasHeader {
        return this.headers.removeHeader(name);
    }

    /**
     * Gets a list of all headers.
     * @return
     * @return {OasHeader[]}
     */
    public getHeaders() : Array<OasHeader> {
        let rval : Array<OasHeader> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, this.headers.getHeaders());
        return rval;
    }

    /**
     * Creates an OAS 2.0 schema object.
     * @return {Oas20Example}
     */
    public createExample() : Oas20Example {
        let rval : Oas20Example = new Oas20Example();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IExampleParent#setExample(java.lang.Object)
     * @param {*} example
     */
    public setExample(example : any) {
        throw Object.defineProperty(new Error("Operation not supported."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IExampleParent#getExample()
     * @return {*}
     */
    public getExample() : any {
        throw Object.defineProperty(new Error("Operation not supported."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }
}
Oas20Response["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Response";
Oas20Response["__interfaces"] = ["io.apicurio.datamodels.openapi.models.IOasHeaderParent","io.apicurio.datamodels.core.models.common.IExampleParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




